import { useEffect, useRef } from 'react';

import { FieldErrors } from 'react-hook-form';

const ERROR_CLASS_SELECTOR = '.text-red-500';
const ERROR_PULSE_CLASSES = ["ring-2", "ring-offset-4", "ring-red-900"];
const PULSE_DURATION = 1000;

export function useScrollToError(
  errors: FieldErrors,
  scrollOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'center',
    inline: 'center',
  }
) {
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (!Object.keys(errors).length) return;

    const errorFields = Object.entries(errors);
    const firstErrorField = errorFields?.[0]?.[0];

    if (!firstErrorField) return;
    const element = document.getElementById(firstErrorField);
    if (element) {
      element.scrollIntoView(scrollOptions);
      highlightErrorField(element);
      return;
    }

    const errorMessageElements = document.querySelectorAll(ERROR_CLASS_SELECTOR);
    if (errorMessageElements.length > 0) {
      errorMessageElements[0].scrollIntoView(scrollOptions);
    }

    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [errors, scrollOptions]);

  const findInputElement = (element: HTMLElement): HTMLElement | null => {
    if (['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName)) {
      return element;
    }

    return element.querySelector('input, textarea, select') as HTMLElement | null;
  };

  const highlightErrorField = (element: HTMLElement) => {
    const inputElement = findInputElement(element);
    if (!inputElement) return;

    inputElement.classList.add(...ERROR_PULSE_CLASSES);
    inputElement.style.transition = "none";
    void inputElement.offsetWidth; //forces css reflow

    timeoutRef.current = window.setTimeout(() => {
      inputElement.classList.remove(...ERROR_PULSE_CLASSES);
    }, PULSE_DURATION);
  };
}